import React from "react";
import ReactDom from "react-dom";
import retargetEvents from "react-shadow-dom-retarget-events";
import App from "./App";

// Polyfills for IE11/Edge. :(
import 'promise-polyfill/src/polyfill';
import "es6-object-assign/auto";
import "document-register-element";
import "@webcomponents/shadydom";

// SSR Hydration mode: if window.__ELECTION_DATA__ exists and #election-root is present,
// mount the app there directly (no Shadow DOM, no custom element needed)
const ssrRoot = document.getElementById("election-root");
if (ssrRoot && window.__ELECTION_DATA__) {
  const { widget } = window.__ELECTION_DATA__;
  const eventId = widget.eventId || "";
  const widgetId = widget.id || "";
  // Clear any pre-rendered SEO content and mount React
  ssrRoot.innerHTML = '';
  ReactDom.render(<App eventId={eventId} widgetId={widgetId} />, ssrRoot, () => {
    // Make visible only after React has finished rendering
    ssrRoot.style.visibility = 'visible';
  });
}

class CMGElections extends HTMLElement {
  connectedCallback() {
    const eventId = this.getAttribute("event-id");
    const widgetId = this.getAttribute("widget-id");

    if (!widgetId) {
      console.error("[cmg-elections] widget-id attribute value must be provided")
    } else if (!eventId) {
      console.error("[cmg-elections] event-id attribute value must be provided")
    } else {
      if (process.env.NODE_ENV === "production") {
        // Production builds isolate the app into a shadow DOM. This requires
        // that we reference the CSS directly. Please make sure the
        // PUBLIC_URL environment property is set correctly.
        // See .env.production.
        const mountPoint = document.createElement("span");
        mountPoint.id = "election-root";
        const shadow = this.attachShadow({ mode: "open" });

        const cssElem = document.createElement("link");
        cssElem.setAttribute("rel", "stylesheet");
        cssElem.setAttribute("href", process.env.PUBLIC_URL + "/static/css/main.css");
        // the line below is for testing webviews - please keep it commented out till needed
        // cssElem.setAttribute("href", "https://preview-staging.whio.com/assets/donuts/main.css");

        shadow.appendChild(cssElem);
        shadow.appendChild(mountPoint);

        ReactDom.render(<App eventId={eventId} widgetId={widgetId} />, mountPoint);

        retargetEvents(shadow);
      } else {
        // Development builds don't isolate the app into a shadow DOM for ease
        // of development.
        this.id = "election-root";
        ReactDom.render(<App eventId={eventId} widgetId={widgetId} />, this);
      }
    }
  }
}

// Register our React app as a custom element. This can be used in the embed
// code as such:
// <cmg-elections event-id="1234" widget-id="1234"></cmg-elections>
if (!customElements.get("cmg-elections")) {
  customElements.define("cmg-elections", CMGElections);
}
